// Vue utilise les `key` pour reconnaître un même nœud entre deux rendus.
// Un index de tableau n'est pas une identité stable : insérer une ligne avant
// un module décale son index et force Vue à détruire puis recréer le module.
//
// Le WeakMap associe donc une clé stable à chaque objet du template sans
// ajouter de propriété à cet objet. Cette clé reste locale au navigateur et
// n'est jamais enregistrée dans pages_displays.template.
const pageNodeKeys = new WeakMap()
let pageNodeSequence = 0

export function getPageNodeKey(node) {
    if (!node || typeof node !== 'object') return String(node)

    if (!pageNodeKeys.has(node)) {
        pageNodeSequence += 1
        pageNodeKeys.set(node, `page-node-${pageNodeSequence}`)
    }

    return pageNodeKeys.get(node)
}
